module.exports = __webpack_public_path__ + "static/media/pump_img.b874553d.png";